const numericCharacters = "1234567890";

/** as per the requirement, only numbers and + symbol is allowed;
 * and no spaces */

function validateMobile(mobile) {
	const indexOfPlus = mobile.indexOf("+");
	if (mobile.indexOf(" ") >= 0 || indexOfPlus > 0) {
		return false
	}
	const substrMobileNumber = (indexOfPlus === 0) ? mobile.substr(1) : mobile;
	const result = [...substrMobileNumber].every((v) => numericCharacters.includes(v))
	return result;
}

export default validateMobile;
